import * as  React from 'react';
import {ServicesState} from "../../../Store/Reducers/Dac/types";
import ReactTable from "react-table-6";
//@ts-ignore
import matchSorter from 'match-sorter';
import ActionsCatalogue from "./ActionsCatalogue/ActionsCatalogue";

interface Props {
    data: Array<ServicesState>
}

interface State {
    selectedItems: Array<string>,
    checkAll: boolean,
    copiedCell: string | null
}

class HeaderTableCatalogue extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            selectedItems: [],
            checkAll: false,
            copiedCell: null
        }
    }

    onCheckAllChange = () => {
        if (!this.state.checkAll) {
            const newSelect = Array.from(this.props.data, d => d._id);
            if (newSelect.length > 0) {
                // @ts-ignore
                this.setState({
                    checkAll: true, selectedItems: newSelect
                });
            }
        } else {
            this.setState(prevState => ({...prevState, checkAll: false, selectedItems: []}));
        }
    }

    onSelect = (e: React.FormEvent<HTMLInputElement>, row: any) => {
        const {selectedItems} = this.state;
        if (selectedItems.find(i => i === row.original._id)) {
            this.setState(prevState => ({
                ...prevState,
                selectedItems: selectedItems.filter(i => i !== row.original._id)
            }))
        } else {
            this.setState(prevState => ({...prevState, selectedItems: [...selectedItems, row.original._id]}))
        }

    }

    onDeselectAll = () => {
        this.setState(state => ({...state, selectedItems: []}))
    }

    copyToClipboard = (text: string, cellId: string) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                // Visual feedback - set the copied cell ID
                this.setState({ copiedCell: cellId });
                
                // Reset the copied cell after a short delay
                setTimeout(() => {
                    this.setState({ copiedCell: null });
                }, 1000);
                
                console.log('Text copied to clipboard');
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    }

    renderCellWithCopy = (value: string, rowId: string, columnId: string) => {
        const cellId = `${rowId}-${columnId}`;
        const isCopied = this.state.copiedCell === cellId;
        
        return (
            <span 
                onClick={() => this.copyToClipboard(value, cellId)}
                style={{ 
                    cursor: 'pointer',
                    backgroundColor: isCopied ? '#e6f7ff' : 'transparent',
                    padding: '4px 8px',
                    borderRadius: '2px',
                    transition: 'background-color 0.3s',
                    position: 'relative',
                    display: 'inline-block'
                }}
                title="Click to copy"
            >
                {value}
                {isCopied && (
                    <span style={{
                        position: 'absolute',
                        top: '-20px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#397CF8',
                        color: 'white',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        whiteSpace: 'nowrap'
                    }}>
                        Copied!
                    </span>
                )}
            </span>
        );
    }

    render() {
        const {selectedItems} = this.state;
        const columns: any = [
            {
                Header: <input
                    onChange={this.onCheckAllChange}
                    type="checkbox"
                    className="check-all"
                />,
                accessor: 'volume',
                Cell: (row: any) =>
                    <input
                        type="checkbox"
                        className="choice-table"
                        checked={!!this.state.selectedItems.find(i => i === row.original._id)}
                        onChange={(e) => this.onSelect(e, row)}
                    />
                ,
                sortable: false,
                maxWidth: 70
            },
            {
                Header: "Famille de service",
                accessor: "family",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['family']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(row.value, row.original._id, "family")
            },
            // {
            //     Header: "Désignation",
            //     accessor: "designation",
            //     filterable: true,
            //     filterAll: true,
            //     filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['designation']}),
            //     Filter: ({filter, onChange}: any) =>
            //         <input placeholder="..." className='text-center inputfilters'
            //                onChange={event => onChange(event.target.value)}/>,
            //     Cell: (row: any) => this.renderCellWithCopy(row.value, row.original._id, "designation")
            // },
            {
                Header: "Solution",
                accessor: "solution",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['solution']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => {
                    const cellId = `${row.original._id}-solution`;
                    const isCopied = this.state.copiedCell === cellId;
                    
                    return (
                        <div style={{ position: 'relative' }}>
                            <div 
                                onClick={() => this.copyToClipboard(row.value, cellId)}
                                style={{ 
                                    cursor: 'pointer',
                                    backgroundColor: isCopied ? '#e6f7ff' : 'transparent',
                                    padding: '4px 8px',
                                    borderRadius: '2px',
                                    transition: 'background-color 0.3s',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                                title="Click to copy"
                            >
                                {row.value}
                            </div>
                            {isCopied && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-20px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    backgroundColor: '#397CF8',
                                    color: 'white',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    whiteSpace: 'nowrap',
                                    zIndex: 1000
                                }}>
                                    Copied !
                                </span>
                            )}
                        </div>
                    );
                },
                width: 400
            },
            {
                Header: "Description",
                accessor: "describe_solution",
                filterable: true,
                filterAll: true,
                filterMethod: (filter:any, rows:any) =>  matchSorter(rows, filter.value, {keys: ['describe_solution']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(row.value, row.original._id, "describe_solution"),
            },
            {
                Header: "Durée",
                accessor: "duration",
                filterable: true,
                filterAll: true,
                filterMethod: (filter : any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['duration']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(row.value, row.original._id, "duration"),
                width: 50
            },
            {
                Header: "FRN",
                accessor: "frn",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['frn']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(row.value, row.original._id, "frn")
            },
            {
                Header: "ABO Mois HT",
                accessor: "abo_ht",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['abo_ht']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.abo_ht} €`, row.original._id, "abo_ht")
            },
            {
                Header: "PA ABO (€)",
                accessor: "pa_abo",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['pa_abo']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.pa_abo} €`, row.original._id, "pa_abo")
            },
            {
                Header: "FAS HT (€)", 
                accessor: "fas_ht",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['fas_ht']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.fas_ht} €`, row.original._id, "fas_ht")
            },
            {
                Header: "PA FAS (€)",
                accessor: "pa_fas",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['pa_fas']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.pa_fas} €`, row.original._id, "pa_fas")
            },
            {
                Header: "MGE ABO (€)",
                accessor: "mge_abo",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['mge_abo']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.mge_abo} €`, row.original._id, "mge_abo")
            },
            {
                Header: "TX ABO (%)",
                accessor: "tx_abo",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['tx_abo']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.tx_abo} %`, row.original._id, "tx_abo")
            },
            {
                Header: "MGE FAS (€)",
                accessor: "mge_fas",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['mge_fas']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.mge_fas} €`, row.original._id, "mge_fas")
            },
            {
                Header: "TX FAS (%)",
                accessor: "tx_fas",
                filterable: true,
                filterAll: true,
                filterMethod: (filter: any, rows: any) =>  matchSorter(rows, filter.value, {keys: ['tx_fas']}),
                Filter: ({filter, onChange}: any) =>
                    <input placeholder="..." className='text-center inputfilters'
                           onChange={event => onChange(event.target.value)}/>,
                Cell: (row: any) => this.renderCellWithCopy(`${row.original.tx_fas} %`, row.original._id, "tx_fas")
            },
        ];
        return (
            <>
                <ReactTable showPaginationTop={true}
                            showPaginationBottom={false}
                            data={this.props.data}
                            columns={columns}
                            minRows={10}/>
                <ActionsCatalogue deselectAll={this.onDeselectAll} selectedServices={this.props.data.filter(d => selectedItems.includes(d._id))}
                                  selectedItems={selectedItems}/>
            </>
        )
    }
}

export default HeaderTableCatalogue;